<div class="containerDialog">
  <div class="containerDialog__title">
    <h2 *ngIf="data?.title">{{data.title}}</h2>
    <p *ngIf="data?.subtitle">
      {{data?.subtitle}}
    </p>
  </div>
  <mat-list dense *ngIf="dataList?.length" class="list-data">
    <mat-list-item class="mat-list-item-small" *ngFor="let li of dataList"> {{li}} </mat-list-item>
  </mat-list>
  <div class="containerDialog__buttons">
    <signaturit-button *ngIf="data?.buttonCancel" text="{{data?.buttonCancel}}" type="ghost" size="md"
      (click)="deniedAction()"></signaturit-button>
    <signaturit-button *ngIf="data?.buttonAccept" text="{{data?.buttonAccept}}" type="secondary" size="md"
      (click)="confirmAction()"></signaturit-button>
  </div>
</div>